import React, {Component} from "react";
import {Var} from "../../../App";
import PropTypes from "prop-types";
import './index.css';

class File extends Component {
    constructor(props) {
        super(props);


        this.state = {
            disabled: false,
            readOnly: false,
            error: null,
            value: props.value,
            id: `file_${Var.shuffle('string', 6)}`
        };

        this.ref = {
            input: React.createRef()
        };
    }

    static defaultProps = {
        className: null,
        style: {},
        label: 'فایل را انتخاب کنید ...',
        name: null,
        disabled: false,
        format: [],
        size: null,
        multiple: false,
        validation: _ => true,
        onChange: _ => null
    };
    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        label: PropTypes.string,
        name: PropTypes.string,
        disabled: PropTypes.bool,
        format: PropTypes.arrayOf(PropTypes.oneOf(['image/*', '.png', '.jpg', '.svg'])),
        size: PropTypes.number,
        multiple: PropTypes.bool,
        validation: PropTypes.func,
        onChange: PropTypes.func
    };

    render() {
        const {state, props} = this;
        const cls = ['File'];
        const disabled = state.disabled || props.disabled;
        const id = props.id || state.id;
        let label = props.label;

        if (state.value) {
            if (props.multiple)
                label = `${state.value.length} فایل انتخاب شده`;
            else
                label = 'فایل انتخاب شده';
            cls.push('green');
        }

        if (state.error) {
            label = state.error;
            cls.push('red');
        }

        props.className && cls.push(props.className);
        disabled && cls.push('disabled');

        return <div className={cls.join(' ')} style={props.style}>
            <div className={'File-wrapper'} label={label}>
                <input ref={this.ref.input}
                       type={'file'}
                       className={'File-control'}
                       id={id}
                       multiple={props.multiple}
                       accept={props.format.join(',')}
                       name={props.name || id}
                       disabled={disabled}
                       onChange={this.inputChangeHandler.bind(this)}
                       style={{direction: props.direction}}/>
            </div>
        </div>;
    };

    disabled(disabled = false) {
        this.setState({disabled});
    }

    error(prompt = null) {
        this.setState({error: prompt});
    }

    inputChangeHandler(event) {
        const {props} = this;
        let value = event.target.files;
        const size = Object.values(value || {}).reduce((sum, item) => sum + item.size, 0) / 1024 / 1024;

        if (props.size && size > props.size) {
            this.setState({error: 'حجم فایل زیاد است.'});
            event.target.value = '';
        }

        this.validate(value);
        this.setState({value});

        props.onChange(value);
    };

    validate(value = this.state.value) {
        const {props} = this;
        const validate = props.validation(value);

        if (validate === true)
            this.error();
        else
            this.error(validate);

        return validate === true ? true : {
            label: props.label || props.placeholder || '',
            message: validate
        };
    }
}

export default File;